import { render, staticRenderFns } from "./ProviderOrderSubmitPage.vue?vue&type=template&id=c76319ac&"
import script from "./ProviderOrderSubmitPage.vue?vue&type=script&lang=js&"
export * from "./ProviderOrderSubmitPage.vue?vue&type=script&lang=js&"
import style0 from "./ProviderOrderSubmitPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports